import React, { useState } from "react";
import { InputLabel, MenuItem, Select, FormControl } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getStyles } from "../../../theme/styles";

interface CourseViewSelectorProps {
  siteId: number;
  onChange: any;
}

export default function CourseViewSelector({
  siteId,
  onChange,
}: CourseViewSelectorProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [viewType, setViewType] = useState("");

  const handleChange = (event: any) => {
    setViewType(event.target.value);
    onChange(event.target.value);
  };

  return <>
    <FormControl sx={styles.pFormControl} variant="standard">
      <InputLabel htmlFor="viewType">Select View</InputLabel>
      <Select
        variant="standard"
        value={viewType}
        onChange={handleChange}
        inputProps={{
          name: "viewType",
          id: "viewType",
          "data-testid": "test-viewType",
          role: "option",
        }}
        disabled={!siteId}>
        <MenuItem value="dashboard" role="option">
          Dashboard View
        </MenuItem>
        <MenuItem value="schedule" role="option">
          Schedule Details
        </MenuItem>
        <MenuItem value="clone" role="option">
          Clone Schedule
        </MenuItem>
      </Select>
    </FormControl>
  </>;
}
